import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import { ComplaintOrderingField } from "../types/api/complaints";
import { fetchComplaintsList } from "../services/complaints";
import { FeedbackStatus } from "../types/api/feedback";

export const useComplaintsQuery = (
  search: string = "",
  page: number,
  limit: number,
  ordering?: ComplaintOrderingField,
  status?: FeedbackStatus
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["complaints", search, page, limit, ordering, status],
    queryFn: () =>
      fetchComplaintsList({
        search: search || undefined,
        limit,
        offset: (page - 1) * limit,
        ordering,
        status,
      }),
    retry: 0,
  });
};

// Хук для бесконечной прокрутки жалоб
export const useComplaintsInfiniteQuery = (
  search: string = "",
  limit: number,
  ordering?: ComplaintOrderingField,
  options?: {
    enabled?: boolean;
  }
) => {
  return useInfiniteQuery({
    queryKey: ["complaints-infinite", search, limit, ordering],
    queryFn: ({ pageParam = { limit: limit, offset: 0 } }) =>
      fetchComplaintsList({
        search: search || undefined,
        limit: pageParam.limit,
        offset: pageParam.offset,
        ordering,
      }),
    initialPageParam: { limit: limit, offset: 0 },
    getNextPageParam: (lastPage, allPages) => {
      const totalLoaded = allPages.reduce(
        (acc, page) => acc + page.list.length,
        0
      );
      const hasMore = lastPage.list.length === limit;
      return hasMore ? { limit: limit, offset: totalLoaded } : undefined;
    },
    retry: 0,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
